//
//
//
//
//
//
//
//


export default {
	name: 'BtnTop',

	data: function data() {
		return {
			isVisible: false
		};
	},


	methods: {
		scrollHandler: function scrollHandler() {
			if (window.pageYOffset > document.documentElement.clientHeight && !this.isFixed) this.isVisible = true;else if (window.pageYOffset < document.documentElement.clientHeight) this.isVisible = false;
		}
	},

	mounted: function mounted() {
		window.addEventListener('scroll', this.scrollHandler);
		this.scrollHandler();
	},
	destroyed: function destroyed() {
		window.removeEventListener('scroll', this.scrollHandler);
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/BtnTop.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/BtnTop.vue
// module chunks = 0